<template>
  <div>
    <router-link
      :class="$root.listItemClasses"
      :to="{ name: 'newsletter_type', params: { newsletterTypeId: newsletter_type.id }}"
      v-for="newsletter_type in provider.provider_newsletter_types"
       v-bind:key="newsletter_type.id"
    >
      {{ newsletter_type.name }}
      <span
        class="badge badge-sm badge-primary"
        v-if="newsletter_type.requires_subscription"
      >Subscribers Only</span>
      <span
        class="badge badge-sm badge-info"
        v-if="newsletter_type.parent_newsletter_type_id"
      >Subtype</span>
      <span
        class="badge badge-sm badge-secondary"
        v-if="newsletter_type.digest"
      >Digest</span>
      <span
        class="badge badge-sm badge-warning"
        v-if="!newsletter_type.visible"
      >Hidden</span>
      <span
        class="badge badge-sm badge-info"
        v-if="!newsletter_type.is_public"
      >Private</span>
      <span
        class="badge badge-sm badge-danger"
        v-if="newsletter_type.inactive"
      >Inactive</span>
    </router-link>
  </div>
</template>
<script>
import { mapState } from 'vuex'

export default {
  computed: mapState({
    base: state => state.base,
    provider: state => state.ProviderModule.provider
  })
}
</script>



// WEBPACK FOOTER //
// src/components/NewsletterTypeListItems.vue